import { render, staticRenderFns } from "./VSelectWithValidation.vue?vue&type=template&id=3960f090&scoped=true&"
import script from "./VSelectWithValidation.vue?vue&type=script&lang=js&"
export * from "./VSelectWithValidation.vue?vue&type=script&lang=js&"
import style0 from "./VSelectWithValidation.vue?vue&type=style&index=0&id=3960f090&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3960f090",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VListItem,VListItemContent,VListItemTitle,VSelect})
